import { render, staticRenderFns } from "./comUpload.vue?vue&type=template&id=520dab94"
import script from "./comUpload.vue?vue&type=script&lang=js"
export * from "./comUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports